module.exports = __webpack_public_path__ + "img/yq.89f235ab.png";